import AjudaPage from '@/modules/system/ajuda';
import PdfDpePage from '@/modules/system/utilitarios/PdfDpePage';
import AttendanceSheetEditPage from './modules/business/attendance-sheet/presentation/pages/edit/EditPage';
import AttendanceSheetsPerInternPage from './modules/business/attendance-sheet/presentation/pages/perIntern/PerInternPage';
import AtuacoesEditPage from '@/modules/business/atuacao/editar';
import AtuacoesIndexPage from '@/modules/business/atuacao';
import { BreadcrumbActionsProvider } from './shared/contexts/BreadcrumbActionsContext';
import Changelog from './modules/system/changelog';
import ConfiguracoesIndexPage from '@/modules/system/configuracoes';
import ComarcaEditPage from '@/modules/structure/comarca/editar';
import ComarcaIndexPage from '@/modules/structure/comarca';
import DefensorTimeline from './modules/people/presentation/pages/DefensorTimeline';
import DefensoriaEditPage from '@/modules/structure/defensoria/editar';
import DefensoriaIndexPage from '@/modules/structure/defensoria';
import DiretoriaEditPage from '@/modules/structure/diretoria/editar';
import DiretoriaIndexPage from '@/modules/structure/diretoria';
import ConselhoSuperiorPage from '@/modules/structure/conselho-superior';
import ConselhoSuperiorEditPage from '@/modules/structure/conselho-superior/editar';
import DistritoEditPage from '@/modules/structure/distrito/editar';
import DistritosIndexPage from '@/modules/structure/distrito';
import FuncaoEditPage from '@/modules/structure/funcao/editar';
import FuncaoIndexPage from '@/modules/structure/funcao';
import SimuladorFolhaPage from '@/modules/people/simulador-folha';
import GastoEditPage from '@/modules/office/gasto/editar';
import GastoIndex from '@/modules/office/gasto';
import HistoricoIndexPage from './modules/system/historico/historico';
import HolidaysEditPage from './modules/business/holidays/editar';
import HolidaysIndexPage from './modules/business/holidays';
import HomeIndexPage from '@/modules/home';
import HomeIndexMPage from '@/modules/home/indexm';
import HomeIndexFPage from '@/modules/home/indexf';
import InstituicoesEditPage from './modules/structure/instituicoes/editar';
import InstituicoesIndexPage from './modules/structure/instituicoes';
import Links from '@/shared/constants/navegacao';
import Loading from '@/shared/components/Carregando';
import LoginComToken from '@/modules/system/auth/presentation/pages/LoginComToken';
import LoginIndexPage from '@/modules/system/auth/presentation/pages/login';
import LogoutPage from '@/modules/system/auth/presentation/pages/logout';
import LotacoesIndexPage from './modules/business/lotacoes';
import MovimentacaoEditar from '@/modules/business/movimentacoes/pages/EditPage';
import MovimentacaoIndex from './modules/business/movimentacoes/pages/IndexPage';
import MovimentacaoTipoEditar from '@/modules/business/movimentacoes_tipos/pages/EditPage';
import MovimentacaoTipoIndex from '@/modules/business/movimentacoes_tipos/pages/IndexPage';
import AppShell from '@/shared/components/layout/AppShell';
import NotificacoesIndexPage from '@/modules/system/notificacoes';
import NucleoEditPage from '@/modules/structure/nucleo/editar';
import NucleoIndexPage from '@/modules/structure/nucleo';
import Page404 from '@/modules/system/naoEncontrado';
import PeriodoEditPage from './modules/business/periodo/pages/editar';
import PeriodoIndexPage from './modules/business/periodo/pages';
import PontuacoesPage from './modules/business/periodo/pages/pontuacoes';
import ProcessoSeletivoEditPage from './modules/business/processo-seletivo/editar';
import ProcessoSeletivoIndexPage from './modules/business/processo-seletivo';
import ProcessoSeletivoAnalisesPage from './modules/business/processo-seletivo/analises';
import ProcessoNaoDisponivelPage from './modules/business/processo-seletivo/processo-nao-disponivel';
import InscricaoCandidatoPage from './modules/business/candidato/inscricao';
import CandidatoIndexPage from './modules/business/candidato';
import CandidatoDetalhesPage from './modules/business/candidato/detalhes';
import PromoverEstagiarioWizardPage from './modules/business/candidato/presentation/promover-estagiario-wizard/PromoverEstagiarioWizardPage';
import InscricaoConfirmacaoPage from './modules/business/candidato/inscricao-confirmacao';
import LoginCandidatoPage from './modules/business/candidato/login-candidato';
import MeusProcessosPage from './modules/business/candidato/meus-processos';
import CandidatoGestaoArquivosPage from './modules/business/candidato/gestao-arquivos';
import PersonEditPage from './modules/people/presentation/pages/edit';
import PersonIndexPage from './modules/people/presentation/pages';
import AniversariosPage from './modules/people/presentation/pages/AniversariosPage';
import DefensoresAssessoresPage from './modules/people/presentation/pages/DefensoresAssessoresPage';
import PesquisaMovimentacoesPage from './modules/business/movimentacoes/pages/SearchPage';
import PredioEditPage from '@/modules/structure/predio/editar';
import PredioIndex from '@/modules/structure/predio';
import Protected from '@/shared/components/Protected';
import RelatoriosAtividadesFeatureGuard from '@/shared/components/RelatoriosAtividadesFeatureGuard';
import PublicCandidateShell from '@/shared/components/layout/PublicCandidateShell';
import PublicTraineeIndexPage from './modules/transparency/trainee.page';
import RecuperarIndex from '@/modules/system/auth/presentation/pages/recuperar';
import RegrasIndexPage from '@/modules/business/regras';
import RelatorioDefensoresHeader from './modules/business/lotacoes/tabelas/tLotacoesCabecalho';
import RelatorioDefensoresHeaderPublic from './modules/business/lotacoes/tabelas/tLotacoesCabecalhoPublic';
import RelatorioFeriasHeader from './modules/business/periodo/tabelas/rFeriasHeader';
import RelatorioMovimentacoesHeader from './modules/business/movimentacoes/pages/ReportPage';
import RelatoriosAtividadesPage from '@/modules/reports/presentation/pages/RelatoriosAtividadesPage';
import RelatoriosAprovacaoPage from '@/modules/reports/presentation/pages/RelatoriosAprovacaoPage';
import RelatoriosCorregedoriaPage from '@/modules/reports/presentation/pages/RelatoriosCorregedoriaPage';
import NovoRelatorioPage from '@/modules/reports/presentation/pages/RelatorioCivelPage';
import SessoesPage from '@/modules/system/auth/sessoes.page';
import SetorEditPage from '@/modules/structure/setor/editar';
import SetorIndex from '@/modules/structure/setor';
import RelatorioColaboradoresPorSetorPage from '@/modules/structure/setor/relatorio-colaboradores';
import TipoGastoEditPage from '@/modules/office/tipo-gasto/editar';
import TipoGastoIndex from '@/modules/office/tipo-gasto';
import TrocarSenhaIndex from '@/modules/system/auth/presentation/pages/trocarsenha';
import UserProfilePage from '@/modules/system/usuario/user.profile';
import VarasEditPage from '@/modules/structure/vara/EditPage';
import VarasIndexPage from '@/modules/structure/vara/IndexPage';
import VerifiqueEmail from './modules/system/auth/presentation/pages/PageEmail';
import VinculoEditPage from './modules/business/lotacoes/editPage';
import AuditoriasIndexPage from './modules/system/auditorias/AuditoriasIndexPage';
import LogsEmailsPage from './modules/system/auditorias/LogsEmailsPage';
import LogsTasksPage from './modules/system/auditorias/LogsTasksPage';
import RateLimitAuditoriaPage from './modules/system/auditorias/RateLimitAuditoriaPage';

/** Remonta VinculoEditPage a cada navegação para limpar estado/refs ao usar "Salvar e adicionar outro". */
function VinculoEditPageWithKey() {
  const location = useLocation();
  return <VinculoEditPage key={location.key} />;
}

function RedirectLegacyCandidatoLista() {
  const { id } = useParams();
  return <Navigate to={`${Links.Candidato_Index}/${id ?? ''}`} replace />;
}

function RedirectLegacyCandidatoGestaoArquivos() {
  const { id } = useParams();
  return <Navigate to={`${Links.Candidato_Gestao_Arquivos}/${id ?? ''}`} replace />;
}

function RedirectLegacyCandidatoDetalhes() {
  const { id } = useParams();
  return <Navigate to={`${Links.Candidato_Detalhes}/${id ?? ''}`} replace />;
}
import { AttendanceSheetsPerMonthPage } from './modules/business/attendance-sheet/presentation/pages/perMonth/PerMonthPage';
import EstagiarioFolhaAtualPage from './modules/business/attendance-sheet/presentation/pages/estagiario/EstagiarioFolhaAtualPage';
import EstagiarioMinhasFolhasPage from './modules/business/attendance-sheet/presentation/pages/estagiario/EstagiarioMinhasFolhasPage';
import { AttendanceSheetsPendenciasPage } from './modules/business/attendance-sheet/presentation/pages/pendencias/PendenciasPage';
import { Link, Navigate, RouterProvider, createBrowserRouter, useLocation, useParams } from 'react-router-dom';
import { PermissionEnum } from '@/modules/system/auth/domain/enums/permission.enum';
import { RoleEnum } from '@/modules/system/auth/domain/enums/role.enum';
import {
  PERMISSOES_CADASTRO_PESSOAS_CRIACAO,
  PERMISSOES_CADASTRO_PESSOAS_EDICAO,
  PERMISSOES_CADASTRO_PESSOAS_LEITURA,
} from '@/shared/navigation/navigation-person-permissions.utils';
import { Suspense } from 'react';

/** Destino de `<Navigate to={Links.Nao_Autorizado} />` em `Protected` — precisa existir no router (senão RR dispara erro e o `errorElement` vira 404). */
function NaoAutorizadoPage() {
  return (
    <div className="container py-5 text-center">
      <h1 className="h3">Acesso não autorizado</h1>
      <p className="text-muted">Você não tem permissão para esta área do sistema.</p>
      <Link to={Links.Index} className="btn btn-primary mt-2">
        Voltar ao início
      </Link>
    </div>
  );
}

export default function RoutesProvider() {
  const rotasFilhas = GetChildren();

  const rotas = [
    {
      path: Links.Index,
      element: (
        <BreadcrumbActionsProvider>
          <AppShell />
        </BreadcrumbActionsProvider>
      ),
      errorElement: <Page404 />,
      children: rotasFilhas,
    },
    { path: Links.Nao_Existe, element: <Page404 /> },
    { path: Links.Nao_Autorizado, element: <NaoAutorizadoPage /> },
    { path: `${Links.Auth_Login}`, element: <LoginIndexPage /> },
    { path: `${Links.Veirifique_Email}`, element: <VerifiqueEmail /> },
    { path: `${Links.Auth_Logout}`, element: <LogoutPage /> },
    { path: `${Links.Auth_Obter_Token}`, element: <LoginComToken /> },
    { path: '/modulo', element: <Navigate to={Links.Index} replace /> },
    { path: `${Links.Recuperar}`, element: <RecuperarIndex /> },
    {
      path: `${Links.Relatorio_Lotacoes_public}`,
      element: <RelatorioDefensoresHeaderPublic />,
    },
    { path: `${Links.TrocarSenha}`, element: <TrocarSenhaIndex /> },
    {
      path: `${Links.Estagiario_Index_Public}`,
      element: <PublicTraineeIndexPage />,
    },
    {
      path: `${Links.Candidato_Inscricao}/:id`,
      element: (
        <PublicCandidateShell>
          <InscricaoCandidatoPage />
        </PublicCandidateShell>
      ),
    },
    {
      path: `${Links.Candidato_Inscricao_Confirmacao}`,
      element: (
        <PublicCandidateShell>
          <InscricaoConfirmacaoPage />
        </PublicCandidateShell>
      ),
    },
    {
      path: `${Links.Candidato_Login}`,
      element: (
        <PublicCandidateShell>
          <LoginCandidatoPage />
        </PublicCandidateShell>
      ),
    },
    {
      path: `${Links.Candidato_Meus_Processos}`,
      element: (
        <PublicCandidateShell>
          <MeusProcessosPage />
        </PublicCandidateShell>
      ),
    },
    {
      path: `${Links.ProcessoSeletivo_NaoDisponivel}/:id`,
      element: (
        <PublicCandidateShell>
          <ProcessoNaoDisponivelPage />
        </PublicCandidateShell>
      ),
    },
  ];

  const options = {
    future: {
      v7_fetcherPersist: true,
      v7_normalizeFormMethod: true,
      v7_partialHydration: true,
      v7_relativeSplatPath: true,
      v7_skipActionErrorRevalidation: true,
    },
  };
  return (
    <Suspense fallback={<Loading />}>
      <RouterProvider
        future={{ v7_startTransition: true }}
        router={createBrowserRouter(rotas, options)}
      />
    </Suspense>
  );
}

function GetChildren() {
  let rotas = [
    {
      index: true,
      element: <Protected children={<HomeIndexPage />} allowed={[]} />,
    },
    {
      path: `${Links.Eventos_Index}`,
      element: <Protected children={<HomeIndexFPage />} allowed={[]} />,
    },
    {
      path: `${Links.Atuacoes_Criar}`,
      element: (
        <Protected
          children={<AtuacoesEditPage />}
          allowed={[]}
          permissao={{ role: RoleEnum.ATUACAO, level: PermissionEnum.READ }}
        />
      ),
    },
    {
      path: `${Links.Atuacoes_Editar}/:id`,
      element: (
        <Protected
          children={<AtuacoesEditPage />}
          allowed={[]}
          permissao={{ role: RoleEnum.ATUACAO, level: PermissionEnum.READ }}
        />
      ),
    },
    {
      path: `${Links.Atuacoes_Index}`,
      element: (
        <Protected
          children={<AtuacoesIndexPage />}
          allowed={[]}
          permissao={{ role: RoleEnum.ATUACAO, level: PermissionEnum.READ }}
        />
      ),
    },
    {
      path: `${Links.ChangeLog}`,
      element: (
        <Protected
          children={<Changelog />}
          allowed={[]}
          permissao={[
            { role: RoleEnum.CHANGELOG, level: PermissionEnum.READ },
            { role: RoleEnum.ADMIN_ACTIONS, level: PermissionEnum.READ },
          ]}
        />
      ),
    },
    {
      path: `${Links.Comarcas_Criar}`,
      element: (
        <Protected
          children={<ComarcaEditPage />}
          allowed={[]}
          permissao={{ role: RoleEnum.COMARCA, level: PermissionEnum.READ }}
        />
      ),
    },
    {
      path: `${Links.Comarcas_Editar}/:id`,
      element: (
        <Protected
          children={<ComarcaEditPage />}
          allowed={[]}
          permissao={{ role: RoleEnum.COMARCA, level: PermissionEnum.READ }}
        />
      ),
    },
    {
      path: `${Links.Comarcas_Index}`,
      element: (
        <Protected
          children={<ComarcaIndexPage />}
          allowed={[]}
          permissao={{ role: RoleEnum.COMARCA, level: PermissionEnum.READ }}
        />
      ),
    },

    {
      path: `${Links.Defensoria_Criar}`,
      element: (
        <Protected
          children={<DefensoriaEditPage />}
          allowed={[]}
          permissao={{ role: RoleEnum.DEFENSORIA, level: PermissionEnum.READ }}
        />
      ),
    },
    {
      path: `${Links.Defensoria_Editar}/:id`,
      element: (
        <Protected
          children={<DefensoriaEditPage />}
          allowed={[]}
          permissao={{ role: RoleEnum.DEFENSORIA, level: PermissionEnum.READ }}
        />
      ),
    },
    {
      path: `${Links.Defensoria_Index}`,
      element: (
        <Protected
          children={<DefensoriaIndexPage />}
          allowed={[]}
          permissao={{ role: RoleEnum.DEFENSORIA, level: PermissionEnum.READ }}
        />
      ),
    },
    {
      path: `${Links.Diretoria_Editar}/:id`,
      element: (
        <Protected
          children={<DiretoriaEditPage />}
          allowed={[]}
          permissao={{ role: RoleEnum.DEFENSORIA, level: PermissionEnum.READ }}
        />
      ),
    },
    {
      path: `${Links.Diretoria_Criar}`,
      element: (
        <Protected
          children={<DiretoriaEditPage />}
          allowed={[]}
          permissao={{ role: RoleEnum.DEFENSORIA, level: PermissionEnum.READ }}
        />
      ),
    },
    {
      path: `${Links.Diretoria_Index}`,
      element: (
        <Protected
          children={<DiretoriaIndexPage />}
          allowed={[]}
          permissao={{ role: RoleEnum.DEFENSORIA, level: PermissionEnum.READ }}
        />
      ),
    },
    {
      path: `${Links.ConselhoSuperior_Index}`,
      element: (
        <Protected
          children={<ConselhoSuperiorPage />}
          allowed={[]}
          permissao={{ role: RoleEnum.CONSELHO_SUPERIOR, level: PermissionEnum.READ }}
        />
      ),
    },
    {
      path: `${Links.ConselhoSuperior_Editar}`,
      element: (
        <Protected
          children={<ConselhoSuperiorEditPage />}
          allowed={[]}
          permissao={{ role: RoleEnum.CONSELHO_SUPERIOR, level: PermissionEnum.UPDATE }}
        />
      ),
    },
    {
      path: `${Links.Distrito_Criar}`,
      element: (
        <Protected
          children={<DistritoEditPage />}
          allowed={[]}
          permissao={{ role: RoleEnum.DISTRITO, level: PermissionEnum.READ }}
        />
      ),
    },
    {
      path: `${Links.Distrito_Editar}/:id`,
      element: (
        <Protected
          children={<DistritoEditPage />}
          allowed={[]}
          permissao={{ role: RoleEnum.DISTRITO, level: PermissionEnum.READ }}
        />
      ),
    },
    {
      path: `${Links.Distrito_Index}`,
      element: (
        <Protected
          children={<DistritosIndexPage />}
          allowed={[]}
          permissao={{ role: RoleEnum.DISTRITO, level: PermissionEnum.READ }}
        />
      ),
    },
    {
      path: `${Links.Funcao_Criar}`,
      element: (
        <Protected
          children={<FuncaoEditPage />}
          allowed={[]}
          permissao={{ role: RoleEnum.COLABORADOR, level: PermissionEnum.READ }}
        />
      ),
    },
    {
      path: `${Links.Funcao_Editar}/:id`,
      element: (
        <Protected
          children={<FuncaoEditPage />}
          allowed={[]}
          permissao={{ role: RoleEnum.COLABORADOR, level: PermissionEnum.READ }}
        />
      ),
    },
    {
      path: `${Links.Funcao_Index}`,
      element: (
        <Protected
          children={<FuncaoIndexPage />}
          allowed={[]}
          permissao={{ role: RoleEnum.COLABORADOR, level: PermissionEnum.READ }}
        />
      ),
    },
    {
      path: `${Links.SimuladorFolha_Index}`,
      element: (
        <Protected
          children={<SimuladorFolhaPage />}
          allowed={[]}
          permissao={{ role: RoleEnum.COLABORADOR, level: PermissionEnum.READ }}
        />
      ),
    },
    {
      // Relativos ao layout `path: '/'` — mesma URL pública que `Links.Folha_*` (evita mismatch com filhos absolutos).
      path: 'folha-frequencia/:id',
      element: (
        <Protected children={<AttendanceSheetEditPage />} allowed={[]} />
      ),
    },
    {
      path: `${Links.Folha_Frequencia_Index}`,
      element: (<Protected children={<AttendanceSheetsPerMonthPage />} allowed={[]} />),
    },
    {
      path: `${Links.Folha_Frequencia_Pendencias}`,
      element: (
        <Protected children={<AttendanceSheetsPendenciasPage />} allowed={[]} />
      ),
    },
    {
      path: `${Links.Folha_Frequencia_Index}/:estagiarioId`,
      element: (<Protected children={<AttendanceSheetsPerInternPage />} allowed={[]} />),
    },
    {
      path: Links.Estagiario_Folha_Atual,
      element: (<Protected children={<EstagiarioFolhaAtualPage />} allowed={[]} />),
    },
    {
      path: Links.Estagiario_Minhas_Folhas,
      element: (<Protected children={<EstagiarioMinhasFolhasPage />} allowed={[]} />),
    },

    {
      path: `${Links.Auditorias_Index}`,
      element: (
        <Protected
          children={<AuditoriasIndexPage />}
          allowed={[]}
          permissao={{ role: RoleEnum.ADMIN_ACTIONS, level: PermissionEnum.READ }}
        />
      ),
    },
    {
      path: `${Links.Auditorias_LogsUso}`,
      element: <Protected children={<HistoricoIndexPage />} allowed={[]} />,
    },
    {
      path: `${Links.Auditorias_LogsEmails}`,
      element: (
        <Protected
          children={<LogsEmailsPage />}
          allowed={[]}
          permissao={{ role: RoleEnum.ADMIN_ACTIONS, level: PermissionEnum.READ }}
        />
      ),
    },
    {
      path: `${Links.Auditorias_LogsTasks}`,
      element: (
        <Protected
          children={<LogsTasksPage />}
          allowed={[]}
          permissao={{ role: RoleEnum.ADMIN_ACTIONS, level: PermissionEnum.READ }}
        />
      ),
    },
    {
      path: `${Links.Auditorias_RateLimit}`,
      element: (
        <Protected
          children={<RateLimitAuditoriaPage />}
          allowed={[]}
          permissao={{ role: RoleEnum.ADMIN_ACTIONS, level: PermissionEnum.READ }}
        />
      ),
    },
    {
      path: `${Links.Historico_Index}`,
      element: <Protected children={<HistoricoIndexPage />} allowed={[]} />,
    },
    {
      path: `${Links.Configuracoes_Index}`,
      element: (
        <Protected
          children={<ConfiguracoesIndexPage />}
          allowed={[]}
          permissao={{ role: RoleEnum.ADMIN_ACTIONS, level: PermissionEnum.READ }}
        />
      ),
    },
    {
      path: `${Links.Home}`,
      element: <Protected children={<HomeIndexPage />} allowed={[]} />,
    },
    {
      path: `${Links.Instituicoes_Criar}`,
      element: <Protected children={<InstituicoesEditPage />} allowed={[]} />,
    },
    {
      path: `${Links.Instituicoes_Editar}/:id`,
      element: <Protected children={<InstituicoesEditPage />} allowed={[]} />,
    },
    {
      path: `${Links.Instituicoes_Index}`,
      element: <Protected children={<InstituicoesIndexPage />} allowed={[]} />,
    },
    {
      path: `${Links.Notificacoes_index}`,
      element: <Protected children={<NotificacoesIndexPage />} allowed={[]} />,
    },
    {
      path: `${Links.Ajuda}`,
      element: <Protected children={<AjudaPage />} allowed={[]} />,
    },
    {
      path: `${Links.Utilitarios_PdfDpe}`,
      element: <Protected children={<PdfDpePage />} allowed={[]} />,
    },
    {
      path: `${Links.Nucleo_Criar}`,
      element: (
        <Protected
          children={<NucleoEditPage />}
          allowed={[]}
          permissao={{ role: RoleEnum.NUCLEO, level: PermissionEnum.READ }}
        />
      ),
    },
    {
      path: `${Links.Nucleo_Editar}/:id`,
      element: (
        <Protected
          children={<NucleoEditPage />}
          allowed={[]}
          permissao={{ role: RoleEnum.NUCLEO, level: PermissionEnum.READ }}
        />
      ),
    },
    {
      path: `${Links.Nucleo_Index}`,
      element: (
        <Protected
          children={<NucleoIndexPage />}
          allowed={[]}
          permissao={{ role: RoleEnum.NUCLEO, level: PermissionEnum.READ }}
        />
      ),
    },

    // PERSON
    {
      path: `${Links.Pessoa_Index}`,
      element: (<Protected children={<PersonIndexPage />} allowed={[]} permissao={PERMISSOES_CADASTRO_PESSOAS_LEITURA} />),
    },
    {
      path: `${Links.Pessoa_Aniversarios}`,
      element: (<Protected children={<AniversariosPage />} allowed={[]} permissao={PERMISSOES_CADASTRO_PESSOAS_LEITURA} />),
    },
    {
      path: `${Links.Pessoa_Assessores}`,
      element: (<Protected children={<DefensoresAssessoresPage />} allowed={[]} permissao={PERMISSOES_CADASTRO_PESSOAS_LEITURA} />),
    },
    {
      path: `${Links.Pessoa_Criar}`,
      element: (<Protected children={<PersonEditPage />} allowed={[]} permissao={PERMISSOES_CADASTRO_PESSOAS_CRIACAO} />),
    },
    {
      path: `${Links.Pessoa_Editar}/:id`,
      element: (<Protected children={<PersonEditPage />} allowed={[]} permissao={PERMISSOES_CADASTRO_PESSOAS_EDICAO} />),
    },

    {
      path: `${Links.Defensor_Timeline}`,
      element: (<Protected children={<DefensorTimeline />} allowed={[]} permissao={{ role: RoleEnum.DEFENSOR, level: PermissionEnum.READ }} />
      ),
    },
    {
      path: `${Links.Usuario_Profile}`,
      element: (<Protected children={<UserProfilePage />} allowed={[]} />),
    },
    {
      path: Links.Sessoes_Legacy,
      element: <Navigate to={Links.Sessoes_Index} replace />,
    },
    {
      path: `${Links.Sessoes_Index}`,
      element: (
        <Protected
          children={<SessoesPage />}
          allowed={[]}
          permissao={{ role: RoleEnum.ADMIN_ACTIONS, level: PermissionEnum.READ }}
        />
      ),
    },
    {
      path: `${Links.TipoGasto_Index}`,
      element: (
        <Protected
          children={<TipoGastoIndex />}
          allowed={[]}
          permissao={{ role: RoleEnum.ADMIN_ACTIONS, level: PermissionEnum.READ }}
        />
      ),
    },
    {
      path: `${Links.TipoGasto_Criar}`,
      element: (
        <Protected
          children={<TipoGastoEditPage />}
          allowed={[]}
          permissao={{ role: RoleEnum.ADMIN_ACTIONS, level: PermissionEnum.READ }}
        />
      ),
    },
    {
      path: `${Links.TipoGasto_Editar}/:id`,
      element: (
        <Protected
          children={<TipoGastoEditPage />}
          allowed={[]}
          permissao={{ role: RoleEnum.ADMIN_ACTIONS, level: PermissionEnum.READ }}
        />
      ),
    },
    {
      path: `${Links.Gasto_Index}`,
      element: (
        <Protected
          children={<GastoIndex />}
          allowed={[]}
          permissao={{ role: RoleEnum.ADMIN_ACTIONS, level: PermissionEnum.READ }}
        />
      ),
    },
    {
      path: `${Links.Gasto_Criar}`,
      element: (
        <Protected
          children={<GastoEditPage />}
          allowed={[]}
          permissao={{ role: RoleEnum.ADMIN_ACTIONS, level: PermissionEnum.READ }}
        />
      ),
    },
    {
      path: `${Links.Gasto_Editar}/:id`,
      element: (
        <Protected
          children={<GastoEditPage />}
          allowed={[]}
          permissao={{ role: RoleEnum.ADMIN_ACTIONS, level: PermissionEnum.READ }}
        />
      ),
    },
    {
      path: `${Links.Predio_Criar}`,
      element: (
        <Protected
          children={<PredioEditPage />}
          allowed={[]}
          permissao={{ role: RoleEnum.PREDIO, level: PermissionEnum.READ }}
        />
      ),
    },
    {
      path: `${Links.Predio_Editar}/:id`,
      element: (
        <Protected
          children={<PredioEditPage />}
          allowed={[]}
          permissao={{ role: RoleEnum.PREDIO, level: PermissionEnum.READ }}
        />
      ),
    },
    {
      path: `${Links.Predio_Index}`,
      element: (
        <Protected
          children={<PredioIndex />}
          allowed={[]}
          permissao={{ role: RoleEnum.PREDIO, level: PermissionEnum.READ }}
        />
      ),
    },
    {
      path: `${Links.ProcessoSeletivo_Criar}`,
      element: (
        <Protected
          children={<ProcessoSeletivoEditPage />}
          allowed={[]}
          permissao={{ role: RoleEnum.ESTAGIARIO, level: PermissionEnum.READ }}
        />
      ),
    },
    {
      path: `${Links.ProcessoSeletivo_Editar}/:id`,
      element: (
        <Protected
          children={<ProcessoSeletivoEditPage />}
          allowed={[]}
          permissao={{ role: RoleEnum.ESTAGIARIO, level: PermissionEnum.READ }}
        />
      ),
    },
    {
      path: `${Links.ProcessoSeletivo_Index}`,
      element: (
        <Protected
          children={<ProcessoSeletivoIndexPage />}
          allowed={[]}
          permissao={{ role: RoleEnum.ESTAGIARIO, level: PermissionEnum.READ }}
        />
      ),
    },
    {
      path: `${Links.ProcessoSeletivo_Analises}`,
      element: (
        <Protected
          children={<ProcessoSeletivoAnalisesPage />}
          allowed={[]}
          permissao={{ role: RoleEnum.ESTAGIARIO, level: PermissionEnum.READ }}
        />
      ),
    },
    {
      path: `${Links.Candidato_Gestao_Arquivos}/:id`,
      element: (
        <Protected
          children={<CandidatoGestaoArquivosPage />}
          allowed={[]}
          permissao={{ role: RoleEnum.ADMIN_ACTIONS, level: PermissionEnum.READ }}
        />
      ),
    },
    {
      path: `${Links.Candidato_Index}/:id`,
      element: (
        <Protected
          children={<CandidatoIndexPage />}
          allowed={[]}
          permissao={{ role: RoleEnum.ESTAGIARIO, level: PermissionEnum.READ }}
        />
      ),
    },
    {
      path: `${Links.Candidato_Detalhes}/:candidatoId/promover`,
      element: (
        <Protected
          children={<PromoverEstagiarioWizardPage />}
          allowed={[]}
          permissao={{ role: RoleEnum.ESTAGIARIO, level: PermissionEnum.UPDATE }}
        />
      ),
    },
    {
      path: `${Links.Candidato_Detalhes}/:id`,
      element: (
        <Protected
          children={<CandidatoDetalhesPage />}
          allowed={[]}
          permissao={{ role: RoleEnum.ESTAGIARIO, level: PermissionEnum.READ }}
        />
      ),
    },
    {
      path: '/candidato/processo-seletivo/gestao-arquivos/:id',
      element: <RedirectLegacyCandidatoGestaoArquivos />,
    },
    {
      path: '/candidato/processo-seletivo/:id',
      element: <RedirectLegacyCandidatoLista />,
    },
    {
      path: '/candidato/:id',
      element: <RedirectLegacyCandidatoDetalhes />,
    },

    {
      path: `${Links.Setor_Criar}`,
      element: (
        <Protected
          children={<SetorEditPage />}
          allowed={[]}
          permissao={{ role: RoleEnum.PREDIO, level: PermissionEnum.CREATE }}
        />
      ),
    },
    {
      path: `${Links.Setor_Editar}/:id`,
      element: (
        <Protected
          children={<SetorEditPage />}
          allowed={[]}
          permissao={{ role: RoleEnum.PREDIO, level: PermissionEnum.UPDATE }}
        />
      ),
    },
    {
      path: `${Links.Setor_Index}`,
      element: (
        <Protected
          children={<SetorIndex />}
          allowed={[]}
          permissao={{ role: RoleEnum.PREDIO, level: PermissionEnum.READ }}
        />
      ),
    },
    {
      path: `${Links.Setor_Relatorio_Colaboradores}`,
      element: (
        <Protected
          children={<RelatorioColaboradoresPorSetorPage />}
          allowed={[]}
          permissao={{ role: RoleEnum.PREDIO, level: PermissionEnum.READ }}
        />
      ),
    },
    {
      path: `${Links.Varas_Criar}`,
      element: (
        <Protected
          children={<VarasEditPage />}
          allowed={[]}
          permissao={{ role: RoleEnum.VARA, level: PermissionEnum.READ }}
        />
      ),
    },
    {
      path: `${Links.Varas_Editar}/:id`,
      element: (
        <Protected
          children={<VarasEditPage />}
          allowed={[]}
          permissao={{ role: RoleEnum.VARA, level: PermissionEnum.READ }}
        />
      ),
    },
    {
      path: `${Links.Varas_Index}`,
      element: (
        <Protected
          children={<VarasIndexPage />}
          allowed={[]}
          permissao={{ role: RoleEnum.VARA, level: PermissionEnum.READ }}
        />
      ),
    },
    {
      path: `${Links.Pontuacoes_Index}`,
      element: (
        <Protected
          children={<PontuacoesPage />}
          allowed={[]}
        />
      ),
    },
    {
      path: `${Links.Acoes_Criar}/:defensorid`,
      element: (<Protected children={<PeriodoEditPage />} allowed={[]} />
      ),
    },
    {
      path: `${Links.Acoes_Editar}/:id`,
      element: (
        <Protected
          children={<PeriodoEditPage />}
          allowed={[]}
        />
      ),
    },
    {
      path: `${Links.Acoes_Index}/:id`,
      element: (
        <Protected
          children={<PeriodoIndexPage />}
          allowed={[]}
        />
      ),
    },
    {
      path: `${Links.Acoes_Index}`,
      element: (
        <Protected
          children={<PeriodoIndexPage />}
          allowed={[]}
        />
      ),
    },

    {
      path: `${Links.Regras}`,
      element: (
        <Protected
          children={<RegrasIndexPage />}
          allowed={[]}
        />
      ),
    },
    {
      path: `${Links.Relatorio_Ferias}`,
      element: (
        <Protected
          children={<RelatorioFeriasHeader />}
          allowed={[]}
        />
      ),
    },
    {
      path: `${Links.Relatorio_Lotacoes}`,
      element: (
        <Protected
          children={<RelatorioDefensoresHeader />}
          allowed={[]}
        />
      ),
    },
    {
      path: `${Links.Vinculos_Colaboradores_Index}`,
      element: (
        <Navigate to={`${Links.Vinculos_Index}?tipo=colaborador`} replace />
      ),
    },
    {
      path: `${Links.Vinculos_Defensor_Index}`,
      element: (
        <Navigate to={`${Links.Vinculos_Index}?tipo=defensor`} replace />
      ),
    },
    {
      path: `${Links.Vinculos_Estagio_Index}`,
      element: (
        <Navigate to={`${Links.Vinculos_Index}?tipo=estagiario`} replace />
      ),
    },
    {
      path: `${Links.Vinculos_Colaboradores_Criar}`,
      element: (
        <Protected
          children={<VinculoEditPageWithKey />}
          allowed={[]}
        />
      ),
    },
    {
      path: `${Links.Vinculos_Defensor_Criar}`,
      element: (
        <Protected
          children={<VinculoEditPageWithKey />}
          allowed={[]}
        />
      ),
    },
    {
      path: `${Links.Vinculos_Editar}/:id`,
      element: (
        <Protected
          children={<VinculoEditPageWithKey />}
          allowed={[]}
        />
      ),
    },
    {
      path: `${Links.Vinculos_Estagio_Criar}/estagiario/:estagiarioid/estagio/:estagioid`,
      element: (
        <Protected
          children={<VinculoEditPageWithKey />}
          allowed={[]}
        />
      ),
    },
    {
      path: `${Links.Vinculos_Estagio_Criar}`,
      element: (
        <Protected
          children={<VinculoEditPageWithKey />}
          allowed={[]}
        />
      ),
    },
    {
      path: `${Links.Vinculos_Index}`,
      element: (
        <Protected
          children={<LotacoesIndexPage />}
          allowed={[]}
        />
      ),
    },
    {
      path: `${Links.Atividades_Pendentes}`,
      element: (
        <Protected
          children={<HomeIndexMPage />}
          allowed={[]}
        />
      ),
    },
    {
      path: '/movimentacoes',
      element: <Navigate to={Links.Movimentacoes_Index} replace />,
    },
    {
      path: '/movimentacoes/lista',
      element: <Navigate to={Links.Movimentacoes_Lista} replace />,
    },
    {
      path: '/relatorios/movimentacoes',
      element: <Navigate to={Links.Relatorio_Movimentacoes} replace />,
    },
    {
      path: '/movimentacoes/tipos',
      element: <Navigate to={Links.Movimentacoes_Tipos_Index} replace />,
    },
    {
      path: '/movimentacoes/criar',
      element: <Navigate to={Links.Movimentacoes_Criar} replace />,
    },
    {
      path: '/movimentacoes/criar/:defensorid/:mes',
      element: (
        <Protected
          children={<MovimentacaoEditar />}
          allowed={[]}
        />
      ),
    },
    {
      path: '/movimentacoes/editar/:id',
      element: (
        <Protected
          children={<MovimentacaoEditar />}
          allowed={[]}
        />
      ),
    },
    {
      path: '/movimentacoes/:defensorid/:mes',
      element: (
        <Protected
          children={<MovimentacaoIndex />}
          allowed={[]}
        />
      ),
    },
    {
      path: '/movimentacoes/tipos/criar',
      element: (
        <Protected
          children={<MovimentacaoTipoEditar />}
          allowed={[]}
        />
      ),
    },
    {
      path: '/movimentacoes/tipos/editar/:id',
      element: (
        <Protected
          children={<MovimentacaoTipoEditar />}
          allowed={[]}
        />
      ),
    },
    {
      path: `${Links.Movimentacoes_Criar}/:defensorid/:mes`,
      element: (
        <Protected
          children={<MovimentacaoEditar />}
          allowed={[]}
        />
      ),
    },
    {
      path: `${Links.Movimentacoes_Editar}/:id`,
      element: (
        <Protected
          children={<MovimentacaoEditar />}
          allowed={[]}
        />
      ),
    },
    {
      path: `${Links.Movimentacoes_Index}/:defensorid/:mes`,
      element: (
        <Protected
          children={<MovimentacaoIndex />}
          allowed={[]}
        />
      ),
    },
    {
      path: `${Links.Movimentacoes_Index}`,
      element: (
        <Protected
          children={<MovimentacaoIndex />}
          allowed={[]}
        />
      ),
    },
    {
      path: `${Links.Movimentacoes_Tipos_Criar}`,
      element: (
        <Protected
          children={<MovimentacaoTipoEditar />}
          allowed={[]}
        />
      ),
    },
    {
      path: `${Links.Movimentacoes_Tipos_Editar}/:id`,
      element: (
        <Protected
          children={<MovimentacaoTipoEditar />}
          allowed={[]}
        />
      ),
    },
    {
      path: `${Links.Movimentacoes_Tipos_Index}`,
      element: (
        <Protected
          children={<MovimentacaoTipoIndex />}
          allowed={[]}
        />
      ),
    },
    {
      path: `${Links.Relatorio_Movimentacoes}`,
      element: (
        <Protected
          children={<RelatorioMovimentacoesHeader />}
          allowed={[]}
        />
      ),
    },
    {
      path: `${Links.Relatorios}`,
      element: (
        <Protected
          children={
            <RelatoriosAtividadesFeatureGuard>
              <RelatoriosAtividadesPage />
            </RelatoriosAtividadesFeatureGuard>
          }
          allowed={[]}
        />
      ),
    },
    {
      path: `${Links.Relatorios_Criar}`,
      element: (
        <Protected
          children={
            <RelatoriosAtividadesFeatureGuard>
              <NovoRelatorioPage />
            </RelatoriosAtividadesFeatureGuard>
          }
          allowed={[]}
        />
      ),
    },
    {
      path: `${Links.Relatorios_Aprovacao}`,
      element: (
        <Protected
          children={
            <RelatoriosAtividadesFeatureGuard>
              <RelatoriosAprovacaoPage />
            </RelatoriosAtividadesFeatureGuard>
          }
          allowed={[]}
        />
      ),
    },
    {
      path: `${Links.Relatorios_Corregedoria}`,
      element: (
        <Protected
          children={
            <RelatoriosAtividadesFeatureGuard>
              <RelatoriosCorregedoriaPage />
            </RelatoriosAtividadesFeatureGuard>
          }
          allowed={[]}
        />
      ),
    },
    {
      path: `${Links.Movimentacoes_Lista}`,
      element: (
        <Protected
          children={<PesquisaMovimentacoesPage />}
          allowed={[]}
        />
      ),
    },
    {
      path: `${Links.Calendario_Index}`,
      element: (
        <Protected
          children={<HolidaysIndexPage />}
          allowed={[]}
        />
      ),
    },
    {
      path: `${Links.Calendario_Criar}`,
      element: (
        <Protected
          children={<HolidaysEditPage />}
          allowed={[]}
        />
      ),
    },
    {
      path: `${Links.Calendario_Editar}/:id`,
      element: (
        <Protected
          children={<HolidaysEditPage />}
          allowed={[]}
        />
      ),
    },
  ];

  return rotas;
}
